@use "variables" as *;

.mainContainer {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
}

.loadingContainer {
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
}

.loadingStack {
  width: 100%;
  align-self: center;
  padding-left: 20%;
  padding-right: 20%;
  font-size: $fontSize-m;
  font-weight: bolder;
  text-align: center;
}

.progressBar {
  border-radius: 5px;
}

.shelvingContainer {
  display: grid;
  width: 100%;
  height: 100%;
  overflow: auto !important;
}

.shelving {
  display: grid;
  position: relative;
  padding: $spacing-l;
}

.contentUnavailable {
  position: relative;
  width: 100%;
  height: 100%;
}

.breadcrumbDiv {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-shrink: 0;
  margin-bottom: $spacing-m;
}

.breadcrumbStack {
  display: flex;
  width: 100%;
  min-height: 70px;
  align-items: center;
  flex-shrink: 0;
}

.breadcrumb {
  padding: $spacing-s $spacing-m;
}

.breadcrumbElement {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-shrink: 1 !important;
  padding-top: $spacing-s;
}

.breadcrumbText {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tutorialText {
  font-size: $fontSize-s;
}

.zoomSlider {
  width: 100%;
}

.statsStack {
  display: flex;
  padding: 0 $spacing-l $spacing-s $spacing-l;
}
